export default "__VITE_ASSET__CGW9lt56__"